<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>代销协议管理</span> <a-icon type="right" />
            <span style="font-weight: 500">详情</span>
          </div>
        </div>
      </template>
      <template slot="extra">
        <a-button v-if="canEdit" type="primary" icon="edit" @click="toEdit" style="margin-right: 8px">编辑</a-button>
        <a-button @click="toBack">返回</a-button>
      </template>

      <a-spin :spinning="loading">
        <!-- 合同主表 -->
        <div class="Basicinformation">
          <h2>合同信息</h2>
          <a-descriptions :column="3" bordered size="small">
            <a-descriptions-item label="合同号">{{ data.contractNo || '----' }}</a-descriptions-item>
            <a-descriptions-item label="合同文本编号">{{ data.textContractNo || '----' }}</a-descriptions-item>
            <a-descriptions-item label="状态">
              <a-tag :color="statusCfg(data.status).color">
                {{ statusCfg(data.status).label }}
              </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="商户号">{{ data.mchNo || '----' }}</a-descriptions-item>
            <a-descriptions-item label="代销账号">{{ data.consignAccountNo || '----' }}</a-descriptions-item>
            <a-descriptions-item label="代销户名">{{ data.consignAccountName || '----' }}</a-descriptions-item>
            <a-descriptions-item label="委托账号">{{ data.entrustAccountNo || '----' }}</a-descriptions-item>
            <a-descriptions-item label="委托户名">{{ data.entrustAccountName || '----' }}</a-descriptions-item>
            <a-descriptions-item label="年度代销限额">
              <Balance :amount="data.consignYearLimit" dcflag="d" :alignRight="false" />
            </a-descriptions-item>
            <a-descriptions-item label="合同起始日期">{{ data.contractDateStart || '----' }}</a-descriptions-item>
            <a-descriptions-item label="合同截止日期">{{ data.contractDateEnd || '----' }}</a-descriptions-item>
            <a-descriptions-item label="创建时间">{{ data.createTime || '----' }}</a-descriptions-item>
            <a-descriptions-item label="备注" :span="3">{{ data.remark || '----' }}</a-descriptions-item>
          </a-descriptions>
        </div>

        <!-- 审批信息 -->
        <div class="Basicinformation" v-if="data.status === '2' || data.status === '3' || data.approveRemark">
          <h2>审批信息</h2>
          <a-descriptions :column="3" bordered size="small">
            <a-descriptions-item label="审批结果">
              <a-tag v-if="data.approveResult === 'pass'" color="green">通过</a-tag>
              <a-tag v-else-if="data.approveResult === 'reject'" color="red">拒绝</a-tag>
              <span v-else>----</span>
            </a-descriptions-item>
            <a-descriptions-item label="审批人">{{ data.approver || '----' }}</a-descriptions-item>
            <a-descriptions-item label="审批时间">{{ data.approveTime || '----' }}</a-descriptions-item>
            <a-descriptions-item label="审批备注" :span="3">
              {{ data.approveRemark || '----' }}
            </a-descriptions-item>
          </a-descriptions>
        </div>

      <!-- 代销统计（银行 310913 直查，失败不影响主详情） -->
      <div class="Basicinformation" v-if="data.consignAmount !== undefined">
        <h2>代销统计</h2>
        <a-descriptions :column="3" bordered size="small">
          <a-descriptions-item label="需结算总金额">
            <Balance :amount="data.needSettleAmount" dcflag="c" :alignRight="false" />
          </a-descriptions-item>
          <a-descriptions-item label="已清算金额">
            <Balance :amount="data.settleAmount" dcflag="d" :alignRight="false" />
          </a-descriptions-item>
          <a-descriptions-item label="已分账金额">
            <Balance :amount="data.splitAmount" dcflag="d" :alignRight="false" />
          </a-descriptions-item>
          <a-descriptions-item label="代销金额">
            <Balance :amount="data.consignAmount" :alignRight="false" />
          </a-descriptions-item>
          <a-descriptions-item label="归集金额">
            <Balance :amount="data.poolingAmount" dcflag="d" :alignRight="false" />
          </a-descriptions-item>
          <a-descriptions-item label="还款金额">
            <Balance :amount="data.repayAmount" dcflag="d" :alignRight="false" />
          </a-descriptions-item>
          <a-descriptions-item label="代销年度限额">
            <Balance :amount="data.consignYearLimit" :alignRight="false" />
          </a-descriptions-item>
          <a-descriptions-item label="已用代销年度限额">
            <Balance :amount="data.usedConsignYearLimit" dcflag="c" :alignRight="false" />
          </a-descriptions-item>
        </a-descriptions>
      </div>

        <!-- 合同明细 -->
        <div class="Detailinformation">
          <h2>合同明细（{{ (data.detailList || []).length }}）</h2>
          <a-row :gutter="20">
            <a-col v-for="(d, idx) in (data.detailList || [])" :key="idx"
                   :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <a-card size="small" class="detail-card" :bordered="true">
                <template slot="title">
                  <span>明细 {{ idx + 1 }}</span>
                  <a-tag v-if="d.contractType && contractTypeCfg[d.contractType]"
                         :color="contractTypeCfg[d.contractType].color" style="margin-left: 8px">
                    {{ contractTypeCfg[d.contractType].label }}
                  </a-tag>
                </template>
                <div class="detail-field">
                  <label>对方账号</label>
                  <WalletInfo v-if="d.oppAccountNo"
                              :account-name="d.oppAccountName"
                              :account-no="d.oppAccountNo"
                              :account-class="d.oppAccountClass"
                              :show-account-name="false"
                              :show-account-no="true" />
                  <span v-else class="placeholder">----</span>
                </div>
                <div class="detail-field">
                  <label>对方户名</label>
                  <span>{{ d.oppAccountName || '----' }}</span>
                </div>
                <div class="detail-field">
                  <label>服务费规则</label>
                  <span>{{ d.feeName || d.feeNo || '----' }}</span>
                </div>
                <div class="detail-field">
                  <label>手续费备注</label>
                  <span>{{ d.feeRemark || '----' }}</span>
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
        </a-spin>
    </a-card>
  </div>
</template>

<script>
import Balance from '@/view/components/Balance.vue'
import WalletInfo from '@/view/components/WalletInfo.vue'
import { contractStatusConfig, contractTypeConfig } from '@/utils/bizDict/consignDict'

export default {
  name: 'ConsignContractDetail',
  components: { Balance, WalletInfo },
  data() {
    return {
      loading: false,
      data: { detailList: [] },
      contractTypeCfg: contractTypeConfig,
    }
  },
  computed: {
    // 审批通过(2)/作废(4) 不能编辑,其他状态可编辑
    canEdit() { return this.data && !['2', '4'].includes(this.data.status) },
  },
  methods: {
    statusCfg(v) { return contractStatusConfig[v] || contractStatusConfig.default },
    toBack() { this.$router.back() },
    toEdit() {
      this.$router.push({
        path: '/consign/contract/add',
        query: { contractNo: this.data.contractNo },
      })
    },
    async loadDetail() {
      const contractNo = this.$route.query.contractNo
      if (!contractNo) {
        this.$message.error('合同号缺失')
        return
      }
      this.loading = true
      try {
        const res = await this.api.contractDetailApi(contractNo)
        if (res.code !== 200) {
          this.$message.error(res.info || '查询失败')
          return
        }
        this.data = res.data || { detailList: [] }
      } finally {
        this.loading = false
      }
    },
  },
  mounted() { this.loadDetail() },
}
</script>

<style scoped>
.top-title { display: flex; justify-content: space-between; align-items: center; }
.Basicinformation, .Detailinformation { padding: 0 12px; }
.Basicinformation h2, .Detailinformation h2 {
  font-size: 16px; font-weight: 600; margin: 16px 0 12px; color: #333;
  border-left: 3px solid #1890ff; padding-left: 8px;
}
.detail-card {
  margin-bottom: 16px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  transition: box-shadow 0.2s;
  min-width: 280px;
}
.detail-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.detail-card /deep/ .ant-card-head {
  min-height: 40px;
  padding: 0 14px;
  border-bottom: 1px solid #f0f0f0;
}
.detail-card /deep/ .ant-card-head-title {
  padding: 8px 0;
  font-size: 13px;
}
.detail-card /deep/ .ant-card-extra {
  padding: 6px 0;
}
.detail-card /deep/ .ant-card-body {
  padding: 18px 16px;
}
.detail-field {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  min-height: 32px;
}
.detail-field:last-child { margin-bottom: 0; }
.detail-field label {
  width: 90px;
  color: #666;
  font-size: 13px;
  text-align: right;
  padding-right: 8px;
  flex-shrink: 0;
  white-space: nowrap;
}
.detail-field > span {
  flex: 1;
  min-width: 0;
  color: #333;
  font-size: 13px;
  word-break: break-all;
}
.detail-field .placeholder {
  color: #bbb;
}


</style>
